import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { TableColumn, TextTableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor, ToolbarButton } from '../../components/kiene-table/table-descriptor';
import { Condition, Operator } from '../../components/kiene-table/table-option';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { HeimtierKundeDialogComponent } from '../heimtiere/heimtier-kunde-dialog/heimtier-kunde-dialog.component';
import { HeimtierKundenExcelImportDialogComponent } from './heimtier-kunden-excel-import-dialog/heimtier-kunden-excel-import-dialog.component';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-heimtier-kunden',
    templateUrl: './heimtier-kunden.component.html',
    styleUrls: ['./heimtier-kunden.component.scss'],
})
export class HeimtierKundenComponent implements OnInit {
    public static readonly PERMISSION_VIEW = 7011;
    public static readonly PERMISSION_CREATE = 7012;
    public static readonly PERMISSION_UPDATE = 7012;
    public static readonly PERMISSION_DELETE = 7014;
    tableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        private api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Kunden';
        this.tableDescriptor.uniqueIdentifier = 'Heimtierkunden';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'heimtier_kunde/';

        const columns: TableColumn[] = [];

        columns.push(new TableColumn('bezeichnung', 'Kunde'));
        columns.push(new TextTableColumn('strasse', 'Straße'));
        columns.push(new TextTableColumn('plz', 'Postleitzahl'));
        columns.push(new TextTableColumn('ort', 'Ort'));
        columns.push(new TextTableColumn('email', 'E-Mail'));
        columns.push(new TextTableColumn('telefon_1', 'Telefon'));
        columns.push(new TextTableColumn('mobil_1', 'Mobil'));
        columns.push(new TextTableColumn('kommentar', 'Kommentar'));
        columns.push(new TextTableColumn('kunde_nr_intern', 'Interne Nummer'));

        this.tableDescriptor.columns = columns;

        this.tableDescriptor.initialSortColumn = 'bezeichnung';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.defaultPageSize = 10;

        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.showDetailsVoid = this.openHeimtierKundeDialog.bind(this);

        this.tableDescriptor.permissionView = HeimtierKundenComponent.PERMISSION_VIEW;
        this.tableDescriptor.permissionCreate = HeimtierKundenComponent.PERMISSION_CREATE;

        this.tableDescriptor.toolbarButtons.push(
            new ToolbarButton(this.openExcelImportDialog.bind(this), 'upload', 7015, 'Kunden aus Excel importieren'),
        );

        this.tableDescriptor.disableConditions.push(new Condition('aktiv', Operator.GLEICH, 0));
        this.tableDescriptor.addVoid = this.openHeimtierKundeDialog.bind(this);
    }

    openExcelImportDialog() {
        const dialogRef = this.dialog.open(HeimtierKundenExcelImportDialogComponent, { width: '50%' });

        dialogRef.afterClosed().subscribe(() => {
            this.api.reload();
        });
    }

    openHeimtierKundeDialog(kunde?: Client) {
        const dialogRef = this.dialog.open(HeimtierKundeDialogComponent, { data: kunde });

        dialogRef.afterClosed().subscribe(() => {
            this.api.reload();
        });
    }

    openDeleteDialog(kunde: Client) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '500px',
            data: {
                title: kunde.bezeichnung + ' löschen?',
                text: 'Wollen Sie die Tierart ' + kunde.bezeichnung + ' wirklich löschen?',
            },
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                this.api.deleteEntity(this.apiBaseUrl + 'heimtier_kunde/delete.php', kunde).subscribe({
                    next: () => {
                        this.messageService.infoMessage('Die Tierart wurde erfolgreich gelöscht!');
                        this.api.reload();
                    },
                    error: err => {
                        this.messageService.errorMessage(
                            'Fehler! Es ein Problem beim Löschen der Tierart aufgetreten! ',
                            err,
                        );
                    },
                });
            }
        });
    }
}
